// import axios from 'axios';

// const BASE_URL = process.env.REACT_APP_API_URL;
// const API_URL = '/audits';

// export const getAudits = async () => {
//   const response = await axios.get(`${BASE_URL}${API_URL}`);
//   return response.data;
// };

// export const createAudit = async (auditData) => {
//   const response = await axios.post(`${BASE_URL}${API_URL}`, auditData);
//   return response.data;
// };

// export const updateAuditStatus = async (id, status) => {
//   const response = await axios.patch(`${BASE_URL}${API_URL}/${id}/status`, { status });
//   return response.data;
// };

// export const deleteAudit = async (id) => {
//   const response = await axios.delete(`${BASE_URL}${API_URL}/${id}`);
//   return response.data;
// };

// // Fetch single audit by ID
// export const getAuditById = async (id) => {
//   const response = await axios.get(`${BASE_URL}${API_URL}/${id}`);
//   return response.data;
// };

// // Add a comment to an audit
// export const addAuditComment = async (id, comment, postedBy) => {
//     console.log('Sending comment data:', { comment, postedBy });  // Debug log
    
//     try {
//       const response = await axios.post(`${BASE_URL}${API_URL}/${id}/comments`, { 
//         comment, 
//         postedBy
//       });
//       return response.data;
//     } catch (error) {
//       console.error('Error adding comment:', error);
//       throw error;
//     }
//   };
  
// export const assignTeamToAudit = async (id, teamMembers) => {
//     try {
//       const response = await axios.patch(
//         `${BASE_URL}${API_URL}/${id}/team`,
//         { teamMembers } // Make sure this matches the API's expected format
//       );
//       return response.data;
//     } catch (error) {
//       console.error('Error assigning team to audit:', error.response?.data || error.message);
//       throw error; // Optional: re-throw the error to handle it higher up in the code
//     }
//   };
  

import axios from 'axios';
import { apiConnector } from './apiconnector';

const BASE_URL = process.env.REACT_APP_API_URL; // Using environment variable for API URL
const API_URL = '/audits';

axios.defaults.withCredentials = true;
// Helper to get the token from localStorage
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getAudits = async () => {
  try {

    const response = await apiConnector("GET",`${BASE_URL}${API_URL}`,null, 
    );
    return response;
  } catch (error) {
    console.error('Error fetching user audits:', error);
    throw error;
  }
};
// Fetch all audits assigned to the user
export const getUserAssignedAudits = async () => {
  try {
    const response = await apiConnector("GET",`${BASE_URL}${API_URL}/user-audit`,null, 
    );
    return response;
  } catch (error) {
    console.error('Error fetching user audits:', error);
    throw error;
  }
};

// Fetch a single audit by ID
export const getAuditById = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}${API_URL}/${id}`, {
      
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching audit by ID:', error);
    throw error;
  }
};

// Create a new audit
export const createAudit = async (auditData) => {
  try {
    const response = await apiConnector("POST",`${BASE_URL}${API_URL}`, auditData);
    return response;
  } catch (error) {
    console.error('Error creating audit:', error);
    throw error;
  }
};

// Update the status of an audit
export const updateAuditStatus = async (id, status) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}${API_URL}/${id}/status`,
      { status },
    );
    return response.data;
  } catch (error) {
    console.error('Error updating audit status:', error);
    throw error;
  }
};

// Delete an audit
export const deleteAudit = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting audit:', error);
    throw error;
  }
};

// Add a comment to an audit
export const addAuditComment = async (id, comment, postedBy) => {
  try {
    const response = await axios.post(
      `${BASE_URL}${API_URL}/${id}/comments`,
      { comment, postedBy },
    );
    return response.data;
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error;
  }
};

// Assign team members to an audit
export const assignTeamToAudit = async (id, teamMembers) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}${API_URL}/${id}/team`,
      { teamMembers },
    );
    return response.data;
  } catch (error) {
    console.error('Error assigning team to audit:', error);
    throw error;
  }
};

// For submitting audit findings, comments, or updates (for the user role)
export const submitAuditReport = async (auditId, reportData) => {
  const response = await axios.post(`${BASE_URL}${API_URL}/${auditId}/report`, reportData);
  return response.data;
};

export const getOldReports = async (auditId) => {
  try {
    const response = await axios.get(`${BASE_URL}/audits/${auditId}/reports`);
    return response.data;
  } catch (error) {
    console.error('Error fetching old reports:', error);
    throw error;
  }
};

// Save checklist responses
export const saveChecklistResponses = async (auditId, data) => {
  if (!auditId || !data) {
    throw new Error("Audit ID and data are required for saving checklist responses.");
  }

  // Prepare the request payload based on frontend format
  const { checklistResponses, checklistRemarks } = data;

  // Ensure that checklistResponses is an array and remarks are in the correct format
  if (!Array.isArray(checklistResponses)) {
    throw new Error("Invalid checklist responses format. It should be an array.");
  }

  const requestData = {
    checklistResponses: checklistResponses.map((response) => ({
      checklistItemId: response.checklistItemId,
      response: response.response,
    })),
    checklistRemarks: checklistRemarks || "", // Default to empty if no remarks
  };

  try {
    const response = await apiConnector(
      "PUT",
      `${BASE_URL}/audits/${auditId}/checklist`, // Ensure this matches your backend endpoint
      requestData
    );
    
    if (response.success === true) {
      // console.log('Checklist responses saved successfully!');
      return response.data; // Return the data as confirmation of successful saving
    } else {
      console.error(`Unexpected status code: ${response.status}`);
      throw new Error(`Unexpected status code: ${response.status}`);
    }
  } catch (error) {
    console.error("Failed to save checklist responses:", error);
    throw new Error("Error occurred while saving checklist responses: " + error.message);
  }
};



// Submit verification for an audit
export const submitVerification = async (auditId, userId, verificationData) => {
  try {
    const response = await apiConnector("POST",
      `${BASE_URL}/audits/${auditId}/verify/${userId}`,
      { verificationData }
    );
    return response.data;
  } catch (error) {
    console.error('Error submitting verification:', error);
    throw error;
  }
};
// Fetch audit report for a specific audit ID
export const getAuditReport = async (auditId) => {
  try {
    const response = await axios.get(`${BASE_URL}/audits/${auditId}/report`);
    return response.data;
  } catch (error) {
    console.error('Error fetching audit report:', error);
    throw error;
  }
};
// Fetch a list of users (or responsible persons)
export const getUsers = async () => {
  try {
    // console.log('Fetching users...'); // Debug log to check if the function is called
    
    const response = await apiConnector("GET",`${BASE_URL}/audits/get-users`,null, {
      headers: getAuthHeaders(),
    });
    // console.log(response); // Debug log to check the response
    return response;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
// Fetch observations assigned to a specific user for verification
export const getAssignedObservations = async (userId) => {
  try {
    
    const response = await apiConnector("GET",`${BASE_URL}/audits/observation/verify/${userId}`);
    return response;
  } catch (error) {
    console.error('Error fetching assigned observations:', error);
    throw error;
  }
};
export const getClosureAssignments = async (auditId) => {
  const token = localStorage.getItem('token');
  const response = await apiConnector(
    "GET",
    `${BASE_URL}/audits/audit/${auditId}/closure-assignments`,
    null
  );
  return response;
};

export const submitClosureAssignments = async (auditId, assignment) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/audits/${auditId}/assign-closure`,
      assignment,   
    );
    return response.data;
  } catch (error) {
    console.error('Error submitting closure assignments:', error);
    throw error;
  }
};


export const updateAuditArea = async (auditId, areaId) => {
  try {
    const response = await axios.put(`${BASE_URL}/audits/${auditId}/area`, { areaId });
    return response.data;  // Assuming your backend responds with the updated audit data
  } catch (error) {
    throw new Error('Failed to update audit area');
  }
};

export const getVerificationResponse = async (observationId) => {
  const res = await fetch(`${BASE_URL}/audits/observations/${observationId}/verification`);
  return await res.json(); 
};

export const approveVerificationResponse = async (observationId,reviewerName) => {
  const res = await fetch(`${BASE_URL}/audits/observations/${observationId}/approve`, {
    method: 'POST',
    body: JSON.stringify(reviewerName) 
  });
  return await res.json();
};

export const rejectVerificationResponse = async (observationId, rejectionReason) => {
  const res = await fetch(`${BASE_URL}/audits/observations/${observationId}/reject`, {
    method: 'POST',
    body: JSON.stringify(rejectionReason) 
  });

  return await res.json(); 
};
